export default __webpack_public_path__ + "ba775e9c19fac5c225f7483a24bc37c1.pdf";